<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogAddClient"
    :before-close="doClose"
    width="60%"
    top="5vh"
  >
    <el-form :ref="formRef" :rules="rules" :model="KProductform" label-width="200px">
      <el-form-item prop="brandCode" :label="$t('title.brand')">
        <el-select style="width: 200px" v-model="KProductform.brandCode" :placeholder="$t('desc.select')">
          <el-option
            :label="brandInfo.brandName"
            :value="brandInfo.brandCode"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="kTypeId" :label="$t('title.productLine')">
        <el-select v-model="KProductform.kTypeId" :placeholder="$t('desc.select')">
          <el-option
              v-for="item in MTypeTable"
              :key="item.id"
              :label="item.kType"
              :value="item.id"
            ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="kProduct" :label="$t('title.productCategories')">
        <el-input
          v-model="KProductform.kProduct"
          style="width: 200px"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button v-if="subButtonAuth" :loading="loading" type="success" @click="onSubBtn(formRef)">{{$t('button.confirm')}}</el-button>
        <el-button @click="doClose">{{$t('button.cancel')}}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {getBrandInfos} from "../../../api/api"
export default {
  name: "index",
  props: {
    loading: false,
    subButtonAuth: false,
    title: "",
    formRef:"",
    dialogAddClient: false,
    KProductform: {
      KTypeId: "",
      KType: "",
      KProductId: "",
      kProduct: "",
    },
    MTypeTable:{
      type: Array,
      default: function () {
        return [];
      },
    },
    brandInfo:{},
  },
  data(){
    return{
      rules:{
        brandCode:[{required:true, message: this.$t('tips.needed'), trigger: ['blur','change']}],
        kTypeId:[{required:true, message: this.$t("tips.needed"), trigger: ['blur','change']}],
        kProduct:[{required:true, message: this.$t("tips.needed"), trigger: 'blur'}],
      },
      
    }
  },
  methods: {
    onSubBtn(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          this.$emit("onSubBtn", true);
        } else {
          return false;
        }
      });
    },
    doClose() {
      this.$emit("dialogVisibleEvent", false);
      this.$refs[this.formRef].resetFields();
    },
  },
};
</script>

<style>
</style>
